import React from 'react';

import PropTypes from 'prop-types';
import styled from 'styled-components';

import { StylableComponent, stylePropType } from '@adsk/alloy-react-theme';

const StyledUl = styled.ul`
  list-style: none;
  overflow-y: auto;
  overflow-x: hidden;
  margin: 0;
  padding: 0;
`;

/**
 * List of routes rendered within the SideNavigation component.
 */
const SideNavigationList = React.forwardRef<
  HTMLUListElement,
  StylableComponent<HTMLUListElement> & {
    children?: React.ReactNode;
  }
>(({ style, className, children, ...props }, ref) => (
  <StyledUl
    {...props}
    data-testid="SideNavigationList"
    className={className}
    ref={ref}
    style={style}
  >
    {children}
  </StyledUl>
));

SideNavigationList.displayName = 'SideNavigationList';

SideNavigationList.propTypes = {
  /** Styles applied to the root element */
  style: stylePropType,
  /** Class applied to the root element */
  className: PropTypes.string,
  /** children of SideNavigationList */
  children: PropTypes.node,
};

export default SideNavigationList;
